/* eslint-disable */

export default {
	init() {
		$(".job-listing").on("click", function() {
			$(this).toggleClass('is-open');
			$(this).closest('.job-item').find('.job-role').toggleClass('is-open');
		});
	},
};



// WEBPACK FOOTER //
// ./scripts/routes/history.js